import React from "react"

import { PopupService } from "react-ui-components/components/PopupService"

type PopupStyle = Record<string, unknown>

export const openLoginPopup = async ({
  message,
  style = { backgroundColor: "#ddddddc5" },
  title = "",
}: {
  message?: React.ReactNode
  style?: PopupStyle
  title?: string
} = {}) => {
  const { Login } = await import("../components/LoginScreen/Login")
  const content = message ? (
    <div className="flex text-center flex-col">
      <p className="text-red-800">{message}</p>
      <Login />
    </div>
  ) : (
    <Login />
  )

  PopupService.pushPopup(content, title, style)
}

export const openExchangePointsPopup = async (initialUserCode = "") => {
  const { default: ExchangePointsScreen, exchangePointsPopupStyle } = await import(
    "../components/ExchangePointsScreen"
  )

  PopupService.setPopup(
    <ExchangePointsScreen initialUserCode={initialUserCode} />,
    "",
    exchangePointsPopupStyle,
  )
}

export const openQrProcessingPopup = async ({
  caption,
  message,
  style,
  title,
}: {
  caption?: string
  message?: string
  style?: PopupStyle
  title: string
}) => {
  const { QrScanFeedbackCard } = await import("../components/QrScanFeedbackCard")

  PopupService.setPopup(
    <QrScanFeedbackCard
      variant="processing"
      title={title}
      message={message}
      caption={caption}
    />,
    "",
    style,
  )
}

export const openTicketsPopup = async (isLoggedIn: boolean, style?: PopupStyle) => {
  if (!isLoggedIn) {
    await openLoginPopup()
    return
  }

  const { default: Tickets } = await import("../components/Tickets")
  PopupService.setPopup(<Tickets />, "", style)
}

export const openProfileOrLoginPopup = async (isLoggedIn: boolean) => {
  if (!isLoggedIn) {
    await openLoginPopup()
    return
  }

  const { default: Profile } = await import("../components/Profile")
  PopupService.setPopup(<Profile />)
}

export const openLocationPopup = async ({
  shouldClose,
  style,
}: {
  shouldClose?: () => boolean
  style?: PopupStyle
} = {}) => {
  const [{ UserLocationSelector }, { locationPopupStyle }] = await Promise.all([
    import("../components/UserLocationSelector"),
    import("./popupStyles"),
  ])

  PopupService.setPopup(
    <UserLocationSelector onClose={() => PopupService.setPopup(null)} />,
    "",
    style || locationPopupStyle,
    shouldClose,
  )
}
